import React from 'react';

const LogoHeader = (props) =>{

    return <div className={"text-center"} {...props}>
        <img src="/img/logo_small.png"  className="mt-2 mb-2" width={180} height={52}/>
        <hr style={{marginBottom: 0}}/>
    </div>;
};

export default LogoHeader;


// WEBPACK FOOTER //
// ./src/components/LogoHeader/LogoHeader.js